'use client';

import React, {FC, PropsWithChildren, useReducer, useRef} from 'react';
import {HubspotProvider} from '@aaronhayes/react-use-hubspot-form';

import reducer from './reducer';
import {LandingPageRefContext, LandingPageStateContext} from './store';

export const LandingPageContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const containerInstance = useRef<HTMLElement>(null);
  // Keep the ref out of reducer state — React Compiler flags refs stored
  // in state. The ref is provided through its own context instead, so it
  // never needs merging into a fresh object alongside the reducer state.
  const [innerState, dispatch] = useReducer(reducer, {
    isSticky: false,
    setIsSticky: (newIsSticky) => {
      dispatch({
        type: 'SET_IS_STICKY',
        payload: newIsSticky,
      });
    },
  });

  return (
    <LandingPageRefContext.Provider value={containerInstance}>
      <LandingPageStateContext.Provider value={innerState}>
        <HubspotProvider>{children}</HubspotProvider>
      </LandingPageStateContext.Provider>
    </LandingPageRefContext.Provider>
  );
};
